import type React from 'react';
import Spinner from '@/components/shared/Spinner';

interface SkeletonProps {
	showPackageName?: boolean;
	footerLinks?: 'single' | 'double';
	showSpinner?: boolean;
}

const Skeleton = ({
	showPackageName = false,
	footerLinks = 'double',
	showSpinner = false
}: SkeletonProps): React.JSX.Element => (
	<div className="relative h-full w-full">
		<div className="h-full w-full [animation:deep-pulse_1s_ease-in-out_infinite]">
			<div className="border border-border rounded-lg overflow-hidden bg-white" aria-hidden>
				<div className="flex flex-col items-center p-5 pt-7 gap-5">
					<div className="shrink-0 flex items-center justify-center px-10 h-9 w-full">
						<div className="h-7 w-3/4 bg-muted/90 rounded-md" />
					</div>

					{showPackageName && (
						<div className="flex justify-center w-full px-2">
							<div className="h-4 w-24 bg-muted/90 rounded" />
						</div>
					)}

					<div className="flex flex-col items-center gap-2 shrink-0">
						<div className="h-9 w-24 bg-muted/90 rounded" />
						<div className="h-3 w-28 bg-muted/70 rounded" />
					</div>

					<div className="w-full shrink-0">
						<div className="h-9 w-full bg-muted/90 rounded-md" />
					</div>
				</div>

				<div className="border-t border-border px-3 py-2 bg-secondary/30">
					{footerLinks === 'single' ? (
						<div className="h-4 w-16 bg-muted/70 rounded" />
					) : (
						<div className="flex w-full items-center justify-between gap-4">
							<div className="h-3 w-24 bg-muted/70 rounded" />
							<div className="h-3 w-20 bg-muted/70 rounded" />
						</div>
					)}
				</div>
			</div>
		</div>

		{showSpinner && (
			<div className="absolute inset-0 flex items-center justify-center pointer-events-none">
				<Spinner size="md" variant="muted" className="opacity-50" aria-label="Aanbod laden" />
			</div>
		)}
	</div>
);

export default Skeleton;
